var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-wrapper"},[_c('div',{staticClass:"groupedbarchart"},[_c('div',{ref:"chart",staticClass:"groupedbarcharttarget"})])])}
var staticRenderFns = []

export { render, staticRenderFns }